import React from 'react';

const Key = () => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.17811 5.63781L10.3726 0.443359L11.3083 1.37914L10.3726 2.31559L12.0099 3.95287L11.0741 4.88932L9.43612 3.25137L8.50034 4.18715L9.90401 5.59082L8.96823 6.52727L7.56455 5.12293L6.11389 6.57359C6.56421 7.25789 6.74481 8.08486 6.62077 8.8946C6.49673 9.70433 6.07686 10.4393 5.44235 10.9574C4.80783 11.4756 4.00374 11.74 3.18555 11.6996C2.36737 11.6593 1.5932 11.317 1.01275 10.739C0.431051 10.1594 0.085592 9.38433 0.0435191 8.5643C0.00144619 7.74427 0.265764 6.93788 0.785102 6.30187C1.30444 5.66586 2.0417 5.24566 2.85358 5.12293C3.66547 5.0002 4.49399 5.18372 5.17811 5.63781ZM4.75654 9.80251C4.94934 9.62015 5.10362 9.401 5.21026 9.15799C5.31691 8.91499 5.37375 8.65308 5.37744 8.38773C5.38113 8.12239 5.33159 7.85899 5.23174 7.61312C5.1319 7.36725 4.98377 7.14389 4.79613 6.95624C4.60848 6.76859 4.38512 6.62047 4.13925 6.52062C3.89337 6.42078 3.62998 6.37123 3.36463 6.37492C3.09929 6.37861 2.83737 6.43546 2.59437 6.54211C2.35137 6.64875 2.13222 6.80303 1.94986 6.99582C1.5882 7.37027 1.38809 7.87179 1.39261 8.39235C1.39713 8.91291 1.60594 9.41087 1.97404 9.77898C2.34215 10.1471 2.84011 10.3559 3.36068 10.3604C3.88124 10.3649 4.38276 10.1648 4.75721 9.80317L4.75654 9.80251Z"
      fill="black"
    />
  </svg>
);

export default Key;
